import angular from 'angular';

function EncodeUriFilter() {
	return function (component) {
		return encodeURIComponent(component);
	};
}

export default angular.module('filters.encode-uri', [])
	.filter('encodeURI', EncodeUriFilter)
	.name;



// WEBPACK FOOTER //
// ./project/filters/encode-uri.js